import { render, staticRenderFns } from "./NoItem.vue?vue&type=template&id=8bf5557e&"
import script from "./NoItem.vue?vue&type=script&lang=js&"
export * from "./NoItem.vue?vue&type=script&lang=js&"
import style0 from "./NoItem.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports